import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserInfo } from '@core/services/user-info';
import { map } from 'rxjs';

export const authenticationGuard: CanActivateFn = () => {
  const userInfo = inject(UserInfo);
  const router = inject(Router);

  return userInfo.authenticated$.pipe(
    map((authenticated) => {
      if (!authenticated) {
        return router.createUrlTree(['/auth/login']);
      }

      return authenticated;
    }),
  );
};
